import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
// import AddEditAuction from "../pages/AuctionManagement/AddEditAuction";
// import AuctionManagement from "../pages/AuctionManagement/List";
import BidPackageManagement from "../pages/BidPackageManagement";
// import ViewAuction from "../pages/AuctionManagement/ViewAuction";
import AddEditBidPackageManagement from "../pages/BidPackageManagement/AddEdit";
import ViewBidPackage from "../pages/BidPackageManagement/view";
import Category from "../pages/Category";
import AddEditCategory from "../pages/Category/AddEdit";
import AddEditSubCategory from "../pages/Category/AddEditSubCategory";
import CategoryView from "../pages/Category/view";
import ViewSubCategory from "../pages/Category/ViewSubCategory";
import AddEditFaq from "../pages/cms/FaqManagement/AddEditFaq";
import FaqList from "../pages/cms/FaqManagement/List";
import AddEditEmailTemplate from "../pages/EmailTemplate/AddEditEmailTemplate";
import EmailTemplateList from "../pages/EmailTemplate/List";
import ViewEmailDetail from "../pages/EmailTemplate/ViewEmail";
import GlobalSetting from "../pages/Global Setting";
import AddEditTicket from "../pages/TicketManagement/AddEditTicket";
import TicketManagement from "../pages/TicketManagement/List";
import ViewTicket from "../pages/TicketManagement/ViewTicket";
import AddEditUserManagement from "../pages/UserManagement/AddEditUser";
import UserManagementList from "../pages/UserManagement/List";
import ViewUserManagement from "../pages/UserManagement/ViewUser";
import AddEditSubAdminManagement from "../pages/subadminManagement/addEditSubadmin";
import SubAdminManagementList from "../pages/subadminManagement/List";
import viewSubadmin from "../pages/subadminManagement/viewSubadmin";
import BudFreeManagement from "../pages/BidFreeManagement";
import AddEditBudFreeManagement from "../pages/BidFreeManagement/AddEdit";
import ViewBudFreeManagement from "../pages/BidFreeManagement/view";
import CustomerSupportList from "../pages/CustomerSupport/List";
import ListNotification from "../pages/Notificationmanagement";
import PlaceBids from "../pages/AirdropManagement/PlaceBids";
import AuctionEarnBids from "../pages/AirdropManagement/AuctionEarnBids";
import ShareOnSocialMedia from "../pages/AirdropManagement/ShareOnSocialMedia";

import ViewSubLastCategory from "../pages/Category/ViewSubLastCategory";
import SportsTeamManagement from "../pages/SportTeamManagement/List";
import AddEditSportsTeam from "../pages/SportTeamManagement/AddEditTicket";
import ViewSportsTeam from "../pages/SportTeamManagement/ViewTeam";
import AboutUs from "../pages/cms/AboutUs";
import PaymentTransactions from "../pages/PaymentManagement/PaymentList";
import NotificationTemplateList from "../pages/Notificationmanagement/NotificationTemplate/List";
import EditNotification from "../pages/Notificationmanagement/NotificationTemplate/EditNotification";
import TruckOwnerManagementList from "../pages/TruckOwnerManagement/List";
import AddEditTruckOwner from "../pages/TruckOwnerManagement/AddEditUser";
import ViewTruckOwnerManagement from "../pages/TruckOwnerManagement/ViewUser";
const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

//CMS............................................................ ............................
const CmsPage = lazy(() => import("../pages/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/cms/AddEditCms"));

//MyAccount........................................................................................
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));

const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadingFallback = <div>Loading...</div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = ({ permissions }) => {
  let dataparmition = permissions?.permission || {};
  let data = Object.keys(dataparmition);
  // const hasPermission = (permissionKey) => {
  //   return dataparmition && data.includes(permissionKey);
  // };

  // const routes = [
  //   {
  //     element: <PrivateLayout />,
  //     errorElement: <Page404 />,
  //     children: [
  //       { element: <Navigate to="/dashboard" />, index: true },
  //       {
  //         path: "dashboard",
  //         element: makeLazyComponent(() => <DashboardPage />),
  //       },
  //       {
  //         path: "profile",
  //         element: makeLazyComponent(() => <MyAccount />),
  //       },
  //       {
  //         path: "global-setting",
  //         element: makeLazyComponent(() => <GlobalSetting />),
  //       },

  //       ...(hasPermission("User Management")
  //         ? [
  //           {
  //             path: "user-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <UserManagementList />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditUserManagement />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditUserManagement />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("Auction Management")
  //         ? [
  //           {
  //             path: "auction-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <AuctionManagement />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditAuction />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditAuction />),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewAuction />),
  //               },
  //             ],
  //           },
  //           {
  //             path: "bidding-control",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <AuctionList />),
  //               },
  //               {
  //                 path: "bidnow/:id/:auctionId",
  //                 element: makeLazyComponent(() => <BidNow />),
  //               },
  //               {
  //                 path: "qicket-quantity/:id/:auctionId",
  //                 element: makeLazyComponent(() => <TicketQuantity />),
  //               },
  //               {
  //                 path: "bidding-history/:id/:auctionId/:roomId",
  //                 element: makeLazyComponent(() => <BiddingHistory />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <TicketList />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("Ticket Management")
  //         ? [
  //           {
  //             path: "ticket-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <TicketManagement />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditTicket />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditTicket />),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewUserManagement />),
  //               },

  //             ],
  //           },

  //           {
  //             path: "sports-team-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <SportsTeamManagement />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditSportsTeam />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditSportsTeam />),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewSportsTeam />),
  //               },

  //             ],
  //           },

  //         ]
  //         : []),

  //       ...(hasPermission("Watch Ads and Get Free Bid Management")
  //         ? [
  //           {
  //             path: "watch-ads-and-get-free-bid-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <BudFreeManagement />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => (
  //                   <AddEditBudFreeManagement />
  //                 )),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => (
  //                   <AddEditBudFreeManagement />
  //                 )),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewBudFreeManagement />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("Bid Package Management")
  //         ? [
  //           {
  //             path: "bid-package-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <BidPackageManagement />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => (
  //                   <AddEditBidPackageManagement />
  //                 )),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => (
  //                   <AddEditBidPackageManagement />
  //                 )),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewBidPackage />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("Category Management")
  //         ? [
  //           {
  //             path: "category",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <Category />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditCategory />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditCategory />),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <CategoryView />),
  //               },
  //               {
  //                 path: "add-subcategory/:categoryid",
  //                 element: makeLazyComponent(() => <AddEditSubCategory />),
  //               },
  //               {
  //                 path: "edit-subcategory/:id",
  //                 element: makeLazyComponent(() => <AddEditSubCategory />),
  //               },
  //               {
  //                 path: "view-subcategory/:id",
  //                 element: makeLazyComponent(() => <ViewSubCategory />),
  //               },
  //               {
  //                 path: "viewsubcategory/:id",
  //                 element: makeLazyComponent(() => <ViewSubLastCategory />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),
  //       ...(hasPermission("Subadmin Management")
  //         ? [
  //           {
  //             path: "subadmin-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => (
  //                   <SubAdminManagementList />
  //                 )),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => (
  //                   <AddEditSubAdminManagement />
  //                 )),
  //               },

  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => (
  //                   <AddEditSubAdminManagement />
  //                 )),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),
  //       ...(hasPermission("Email Template Management")
  //         ? [
  //           {
  //             path: "email-template",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <EmailTemplateList />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditEmailTemplate />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditEmailTemplate />),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewEmailDetail />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("Airdrop Management")
  //         ? [
  //           {
  //             path: "airdrop-management",
  //             children: [
  //               {
  //                 path: "placebids",
  //                 element: makeLazyComponent(() => <PlaceBids />),
  //               },
  //               {
  //                 path: "share-on-social-Media",
  //                 element: makeLazyComponent(() => <ShareOnSocialMedia />),
  //               },
  //               {
  //                 path: "auction-to-earn-bids",
  //                 element: makeLazyComponent(() => <AuctionEarnBids />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("CMS Management")
  //         ? [
  //           {
  //             path: "cms",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <CmsPage />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditCms />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditCms />),
  //               },
  //               {
  //                 path: "view/:id",
  //                 element: makeLazyComponent(() => <ViewCms />),
  //               },
  //             ],
  //           },
  //           {
  //             path: "about-us",
  //             element: makeLazyComponent(() => <AboutUs />),
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("FAQ Management")
  //         ? [
  //           {
  //             path: "faq",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <FaqList />),
  //               },
  //               {
  //                 path: "add",
  //                 element: makeLazyComponent(() => <AddEditFaq />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <AddEditFaq />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),
  //       ...(hasPermission("Customer Support")
  //         ? [
  //           {
  //             path: "customer-support",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <CustomerSupportList />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //       ...(hasPermission("Notification management")
  //         ? [
  //           {
  //             path: "notification-setting",
  //             children: [
  //               { index: true, element: makeLazyComponent(() => <ListNotification />) },
  //             ]
  //           },
  //           {
  //             path: "notification-management",
  //             children: [
  //               {
  //                 index: true,
  //                 element: makeLazyComponent(() => <NotificationTemplateList />),
  //               },
  //               {
  //                 path: "edit/:id",
  //                 element: makeLazyComponent(() => <EditNotification />),
  //               },
  //             ],
  //           },
  //         ]
  //         : []),

  //         ...(hasPermission("Payment Management")
  //         ? [
  //           {
  //             path: "payment-management",
  //             children: [
  //               { index: true, element: makeLazyComponent(() => <PaymentTransactions />) },
  //             ]
  //           },
  //         ]
  //         : []),

  //     ],
  //   },
  //   { path: "*", element: <Navigate to="/dashboard" /> },
  // ];
  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        {
          path: "dashboard",
          element: makeLazyComponent(() => <DashboardPage />),
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: makeLazyComponent(() => <GlobalSetting />),
        },

        {
          path: "user-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <UserManagementList />),
            },
            // {
            //   path: "add",
            //   element: makeLazyComponent(() => <AddEditUserManagement />),
            // },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewUserManagement />),
            },
          ],
        },
        {
          path: "truck-owner-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <TruckOwnerManagementList />),
            },
            // {
            //   path: "add",
            //   element: makeLazyComponent(() => <AddEditUserManagement />),
            // },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditTruckOwner />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewTruckOwnerManagement />),
            },
          ],
        },
        //    [
        //     {
        //       path: "auction-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <AuctionManagement />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditAuction />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditAuction />),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewAuction />),
        //         },
        //       ],
        //     },
        //     {
        //       path: "bidding-control",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <AuctionList />),
        //         },
        //         {
        //           path: "bidnow/:id/:auctionId",
        //           element: makeLazyComponent(() => <BidNow />),
        //         },
        //         {
        //           path: "qicket-quantity/:id/:auctionId",
        //           element: makeLazyComponent(() => <TicketQuantity />),
        //         },
        //         {
        //           path: "bidding-history/:id/:auctionId/:roomId",
        //           element: makeLazyComponent(() => <BiddingHistory />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <TicketList />),
        //         },
        //       ],
        //     },
        //   ]

        // ...(hasPermission("Ticket Management")
        //   ? [
        //     {
        //       path: "ticket-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <TicketManagement />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditTicket />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditTicket />),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewUserManagement />),
        //         },

        //       ],
        //     },

        //     {
        //       path: "sports-team-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <SportsTeamManagement />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditSportsTeam />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditSportsTeam />),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewSportsTeam />),
        //         },

        //       ],
        //     },

        //   ]
        //   : []),

        // ...(hasPermission("Watch Ads and Get Free Bid Management")
        //   ? [
        //     {
        //       path: "watch-ads-and-get-free-bid-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <BudFreeManagement />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => (
        //             <AddEditBudFreeManagement />
        //           )),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => (
        //             <AddEditBudFreeManagement />
        //           )),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewBudFreeManagement />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        // ...(hasPermission("Bid Package Management")
        //   ? [
        //     {
        //       path: "bid-package-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <BidPackageManagement />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => (
        //             <AddEditBidPackageManagement />
        //           )),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => (
        //             <AddEditBidPackageManagement />
        //           )),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewBidPackage />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        // ...(hasPermission("Category Management")
        //   ? [
        //     {
        //       path: "category",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <Category />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditCategory />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditCategory />),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <CategoryView />),
        //         },
        //         {
        //           path: "add-subcategory/:categoryid",
        //           element: makeLazyComponent(() => <AddEditSubCategory />),
        //         },
        //         {
        //           path: "edit-subcategory/:id",
        //           element: makeLazyComponent(() => <AddEditSubCategory />),
        //         },
        //         {
        //           path: "view-subcategory/:id",
        //           element: makeLazyComponent(() => <ViewSubCategory />),
        //         },
        //         {
        //           path: "viewsubcategory/:id",
        //           element: makeLazyComponent(() => <ViewSubLastCategory />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),
        // ...(hasPermission("Subadmin Management")
        //   ? [
        //     {
        //       path: "subadmin-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => (
        //             <SubAdminManagementList />
        //           )),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => (
        //             <AddEditSubAdminManagement />
        //           )),
        //         },

        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => (
        //             <AddEditSubAdminManagement />
        //           )),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),
        // ...(hasPermission("Email Template Management")
        //   ? [
        //     {
        //       path: "email-template",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <EmailTemplateList />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditEmailTemplate />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditEmailTemplate />),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewEmailDetail />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        // ...(hasPermission("Airdrop Management")
        //   ? [
        //     {
        //       path: "airdrop-management",
        //       children: [
        //         {
        //           path: "placebids",
        //           element: makeLazyComponent(() => <PlaceBids />),
        //         },
        //         {
        //           path: "share-on-social-Media",
        //           element: makeLazyComponent(() => <ShareOnSocialMedia />),
        //         },
        //         {
        //           path: "auction-to-earn-bids",
        //           element: makeLazyComponent(() => <AuctionEarnBids />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        // ...(hasPermission("CMS Management")
        //   ? [
        //     {
        //       path: "cms",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <CmsPage />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditCms />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditCms />),
        //         },
        //         {
        //           path: "view/:id",
        //           element: makeLazyComponent(() => <ViewCms />),
        //         },
        //       ],
        //     },
        //     {
        //       path: "about-us",
        //       element: makeLazyComponent(() => <AboutUs />),
        //     },
        //   ]
        //   : []),

        // ...(hasPermission("FAQ Management")
        //   ? [
        //     {
        //       path: "faq",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <FaqList />),
        //         },
        //         {
        //           path: "add",
        //           element: makeLazyComponent(() => <AddEditFaq />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <AddEditFaq />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),
        // ...(hasPermission("Customer Support")
        //   ? [
        //     {
        //       path: "customer-support",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <CustomerSupportList />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        // ...(hasPermission("Notification management")
        //   ? [
        //     {
        //       path: "notification-setting",
        //       children: [
        //         { index: true, element: makeLazyComponent(() => <ListNotification />) },
        //       ]
        //     },
        //     {
        //       path: "notification-management",
        //       children: [
        //         {
        //           index: true,
        //           element: makeLazyComponent(() => <NotificationTemplateList />),
        //         },
        //         {
        //           path: "edit/:id",
        //           element: makeLazyComponent(() => <EditNotification />),
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        //   ...(hasPermission("Payment Management")
        //   ? [
        //     {
        //       path: "payment-management",
        //       children: [
        //         { index: true, element: makeLazyComponent(() => <PaymentTransactions />) },
        //       ]
        //     },
        //   ]
        //   : []),
        ,
      ],
    },
    { path: "*", element: <Navigate to="/dashboard" /> },
  ];
  return useRoutes(routes);
};

export default MainRouting;
